/**
 * src/platform/linking.web.ts — WEB external-URL shim (W2). Opens hosted Stripe / e-sign
 * pages in a NEW TAB (noopener) per the spec. NEVER imports @smartbox/* (invariant 1).
 */
export async function openExternalUrl(url: string): Promise<void> {
  if (typeof window !== 'undefined') {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
